const SW_URL = '/sw.js';

export function register() {
  // En développement le SW interfère avec le proxy CRA (PDFs, etc.) — on le désactive.
  // Pour tester la PWA, utiliser `npm run build` puis `serve -s build`.
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register(SW_URL).then((registration) => {
      // Détecter les mises à jour disponibles
      registration.addEventListener('updatefound', () => {
        const installing = registration.installing;
        if (!installing) return;

        installing.addEventListener('statechange', () => {
          if (installing.state === 'installed' && navigator.serviceWorker.controller) {
            // Nouvelle version détectée — informer l'UI
            window.dispatchEvent(
              new CustomEvent('swUpdateAvailable', { detail: { registration } })
            );
          }
        });
      });

    }).catch((err) => {
      if (process.env.NODE_ENV === 'development') {
        console.warn('[SW] Enregistrement échoué :', err);
      }
    });
  });
}

export function applyUpdate(registration) {
  if (registration?.waiting) {
    registration.waiting.postMessage({ type: 'SW_SKIP_WAITING' });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((r) => r.unregister())
      .catch(() => {});
  }
}
